/**
 * 全局事件绑定
 */
import { handleErrorCode } from '@/request/tools';

// 全局处理promise reject中没有捕获的内容
export const handlePromiseReject = () => {
  window.addEventListener('unhandledrejection', e => {
    if (e.message && e.message.type === 'cancelHttp') {
      console.log(e.message.msg);
    }
    if (('data' in e.reason) && e.reason.code !== 0) {
      handleErrorCode(e.reason);
      e.preventDefault();
    }
  });
};



// WEBPACK FOOTER //
// ./src/utils/globalEvent.js